/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdSwitchProps } from './type';

export const switchDefaultProps: TdSwitchProps = { label: [], loading: false, size: 'medium' };
